import { Component, OnInit, Inject } from '@angular/core';
import { Globals } from '../../../../globals'
import { ISpedStudentDemographics } from '../../../../Models/ISpedStudentDemographics'
import { IIepInstance } from '../../../../Models/IIepInstance'
import { IepService } from "../../../../Services/IepService";
import { ILockStatus } from '../../../../Models/ILockStatus';
import { Message } from 'primeng/primeng';
import { Router } from "@angular/router";
import { FormPlanningForTheFutureService } from '../../../../Services/FormPlanningForTheFutureService';
import { IFormPlanningForTheFuture } from "../../../../Models/Forms/IFormPlanningForTheFuture";
import { IReportParameter } from 'src/app/Models/IReportParameter';
import { SpinnerBase } from '../../../Base/SpinnerBase';
import { ReportService } from 'src/app/Services/ReportService';
import { ILookupBase } from '../../../../Models/ILookupBase';
import { LookupService } from 'src/app/Services/LookupService';
import { IIEPMenuItem } from 'src/app/Models/IIepMenuItem';

@Component({
  selector: 'PlanningForTheFuture',
  templateUrl: './PlanningForTheFuture.component.html',
  styleUrls: ['./PlanningForTheFuture.component.css']
})

export class FormPlanningForTheFutureComponent extends SpinnerBase implements OnInit {
  _myGlobals: Globals;
  _baseUrl: string;
  _iepService: IepService;
  _lookupService: LookupService;
  successMessages: Message[];
  errorMessages: Message[];
  studentInfo: ISpedStudentDemographics;
  selectedIepInstance: IIepInstance;
  isLocked: boolean;
  lockStatus: string;
  canEditIep: boolean;
  saveClicked: boolean;
  formPlanningForTheFutureDB: IFormPlanningForTheFuture;
  lookupAssessmentLevelList: ILookupBase[];
  reportParamArray: IReportParameter[];
  selectedMenuItem: IIEPMenuItem;
  fourYearsInFuture: Date;
  calendarYearRangeFourYears: string;

  constructor(
    private globals: Globals, reportService: ReportService,
    private _formPlanningForTheFutureService: FormPlanningForTheFutureService,
    iepService: IepService,
    lookupService: LookupService,
    @Inject('BASE_URL') baseUrl: string,
    public router: Router) {
    super(reportService);
    this._iepService = iepService;
    this._myGlobals = globals;
    this._baseUrl = baseUrl;
    this._lookupService = lookupService;
    this.studentInfo = this._myGlobals.spedStudentDemographics;
    this.selectedIepInstance = this._myGlobals.selectedIepInstance;
  }
  ngOnInit(): void {
    this.LoadFormPlanningForTheFutureDetails();
    this.isLocked = false;
    this.canEditIep = this._myGlobals.canEdit();
    this.successMessages = [];
    this.errorMessages = [];
    this.scrollToTop();
    let today = new Date();
    this.fourYearsInFuture = new Date(today.getFullYear() + 4, 5, 30);
    this.calendarYearRangeFourYears = today.getFullYear() + ':' + (today.getFullYear() + 4);
  }

  LoadFormPlanningForTheFutureDetails(): void {
    this._formPlanningForTheFutureService.getFormPlanningForTheFuture(this._myGlobals.selectedFormDetails.formId)
      .subscribe((res: IFormPlanningForTheFuture) => {
        this.formPlanningForTheFutureDB = res as IFormPlanningForTheFuture

        if (this.formPlanningForTheFutureDB.iepId != null) {
          this.formPlanningForTheFutureDB.iepId = this.selectedIepInstance.iepId;
        }
        if (this.formPlanningForTheFutureDB.iepInstanceId != null) {
          this.formPlanningForTheFutureDB.iepId = this.selectedIepInstance.id;
        }
        if (this.formPlanningForTheFutureDB.projectedSchoolExitDate != null) {
          this.formPlanningForTheFutureDB.projectedSchoolExitDate = new Date(this.formPlanningForTheFutureDB.projectedSchoolExitDate);
        }
      },
        err => console.error(err)
    );
  }

  clearMessages() {
    this.successMessages = [];
    this.errorMessages = [];
  }

  addMessage(msg: Message) {
    if (msg.severity == 'error') {
      this.errorMessages = [...this.errorMessages, msg];
    }
    else {
      this.successMessages = [...this.successMessages, msg];
    }
  }

  loadUnLock(action) {
    this._iepService.lockUnlockForm(this._baseUrl + 'api/Iep/LockUnlockForm?formInstanceId='
      + this._myGlobals.selectedFormDetails.formInstanceId + '&action=' + action)
      .subscribe((res: ILockStatus) => {
        this.isLocked = res.success
        this.lockStatus = res.status
      },
        err => console.error(err)
      );
  }

  edit() {
    this.clearMessages();
    this.saveClicked = false;
    this._iepService.lockUnlockForm(this._baseUrl + 'api/Iep/LockUnlockForm?formInstanceId='
      + this._myGlobals.selectedFormDetails.formInstanceId + '&action=Lock')
      .subscribe((res: ILockStatus) => {
        this.isLocked = res.success
        this.lockStatus = res.status
        if (this.isLocked == true) {
          this.globals.editMode = true;
        }
        else {
          let failedMessage: Message = { severity: 'warn', summary: this.lockStatus }
          this.addMessage(failedMessage);
        }
      });
  }

  //Save the formPlanningForTheFutureDB
  save(action) {
    this.scrollToTop();
    this.clearMessages();
    this.saveClicked = true;

    //update values
    this._formPlanningForTheFutureService.insertUpdateFormPlanningForTheFuture(this.formPlanningForTheFutureDB).subscribe((res: IFormPlanningForTheFuture) => {
        let successMessage: Message = { severity: 'success', summary: 'Record Saved Successfully', detail: res.id.toString() }
        this.addMessage(successMessage);
        if (action == 'Close') {
          this.globals.editMode = false;
          this.loadUnLock("UnLock");
        }
        this.saveClicked = false
      this.LoadFormPlanningForTheFutureDetails();
      },
        (error) => {
          let errorMessage: Message = { severity: 'error', summary: 'Save Failed', detail: error };
          this.addMessage(errorMessage);
          this.saveClicked = false;
        }
      )

  }

  cancel() {
    this.clearMessages();
    this.globals.editMode = false;
    this.loadUnLock("UnLock");
    this.LoadFormPlanningForTheFutureDetails();
  }

  populateReportParameters() {
    this.reportParamArray = [] as IReportParameter[];
    this.reportParamArray.push(
      { parameterName: 'BlankForm', parameterValue: 'false' },
      { parameterName: 'FormInstanceID', parameterValue: this.formPlanningForTheFutureDB.iepFormInstanceId.toString() },
      { parameterName: 'FormVersionID', parameterValue: '17' },
      { parameterName: 'IEPID', parameterValue: this.formPlanningForTheFutureDB.iepId.toString() },
      { parameterName: 'ShowCustomWaterMark', parameterValue: 'false' },
      { parameterName: 'CustomWatermarkText', parameterValue: '' },
      { parameterName: 'isDraft', parameterValue: 'False'  },
      { parameterName: 'PlanAddendumID', parameterValue: this.formPlanningForTheFutureDB.id.toString() },
      { parameterName: 'RequestID', parameterValue: '0' }
    );
  }

  printEnglish() {
    this.populateReportParameters();
    this.printFormCommon(this.formPlanningForTheFutureDB.rdlFileNameEnglish, this.reportParamArray);
  }

  printSpanish() {
    this.populateReportParameters();
    this.printFormCommon(this.formPlanningForTheFutureDB.rdlFileNameSpanish, this.reportParamArray);
  }

}
